import React from 'react';

interface WelcomeHeaderProps {
  // No props needed for now
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = () => {
  return (
    <div style={{ 
      marginBottom: '2rem',
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '1.5rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <h2 style={{ 
        fontSize: 'clamp(1.4rem, 5vw, 1.8rem)', 
        fontWeight: 600, 
        color: '#1e1e1e', 
        marginBottom: '1rem',
        lineHeight: 1.3
      }}>
        Welcome to AskCEO.ai, your AI-powered co-founder for smarter location decisions.
      </h2>
      <p style={{ 
        marginBottom: '1rem', 
        fontSize: 'clamp(0.95rem, 4vw, 1.1rem)', 
        color: '#333',
        lineHeight: 1.5
      }}>
        Use AI tools to discover new business opportunities, analyze your competition, and monitor your location's performance in real time.
      </p>
    </div>
  );
};

export default WelcomeHeader;
